import React from 'react';
import * as R from 'ramda';
import * as countries from 'i18n-iso-countries';
import frenchCountryData from 'i18n-iso-countries/langs/fr.json';

import appartement from './../../../../assets/images/svg/090-flats.svg';
import maison from './../../../../assets/images/svg/069-home.svg';
import palace from './../../../../assets/images/svg/093-palace.svg';
import hotel from './../../../../assets/images/svg/087-hotel.svg';
import peniche from './../../../../assets/images/svg/091-house-2.svg';
import divers from './../../../../assets/images/svg/092-camping-tent.svg';
import residenceSenior from "./../../../../assets/images/svg/147-senior-residence.svg";

import { ModalAddress } from './modals/modalAddress';

export const Address = ({deathDeclaration, userId, isLoading}) => {
    countries.registerLocale(frenchCountryData);
    const contractType = ['', 'Propriétaire', 'Locataire', 'Autre'];
    const assetTypeLogo = ["", appartement, maison, divers, hotel, divers, divers, residenceSenior];
    
    return (
        <section className="card mb-sm">
            <div className="card-header pb-0">
                <div className="grid grid-sm-2 align-items-center">
                    <h2 className="h4 text-uppercase text-secondary font-weight-bolder my-auto">adresse</h2>
                    <div className="grid grid-2 ml-sm-auto align-items-center">
                        <button type="button" data-toggle="modal" data-target="#addressModal" className="btn btn-icon p-1 align-middle o-80 o-100--hover mx-auto"><i className="eva eva-edit-2-outline align-middle fs-lead"></i></button>
                        <div className="custom-control custom-switch mx-auto">
                            <input type="checkbox" className="custom-control-input" id="flexSwitchCheckDefaul2t" required="required"  defaultChecked={deathDeclaration.onBoardingStep > 3} />
                            <label className="custom-control-label" htmlFor="flexSwitchCheckDefaul2t">Valider</label>
                        </div>
                    </div>
                </div>
                <hr className="mb-0" />
            </div>
            <div className="card-body grid grid-sm-2 grid-lg-3 grid-xl-5 gy-3">
                <div className="block flex-row align-items-center">
                    <img className="img-fluid mr-3 h-4" src={assetTypeLogo[deathDeclaration.userResidenceAddress.addressType]} alt="maison" />
                    <p className="h6 text-uppercase font-weight-bold my-auto">{contractType[deathDeclaration.userResidenceAddress.addressContract]}</p>
                </div>
                <div className="flex-row align-items-start grid-column-lg-2">
                    <i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
                    <p className="h5 lh-copy my-auto">
                        {deathDeclaration.userResidenceAddress.addressLine1}<br/>
                        {
                            !R.isNil(deathDeclaration.userResidenceAddress.addressLine2) ? 
                                <>{deathDeclaration.userResidenceAddress.addressLine2}<br/></>
                                
                            : ""
                        }
                        {deathDeclaration.userResidenceAddress.postalCode} {deathDeclaration.userResidenceAddress.city}, {countries.getName(deathDeclaration.userResidenceAddress.country, "fr", {select: "official"})}</p>
                </div>
            </div>
            <ModalAddress deathDeclaration={deathDeclaration} userId={userId} isLoading={isLoading} />
        </section>
    )
}